
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class MobileMenuEntry extends Vue {
  @Prop()
  public label!: string;

  @Prop({ default: 'action' })
  public variant!: 'action' | 'back' | 'clear' | 'header';

  public get cssClass(): { [key: string]: boolean } {
    return {
      'menu-entry--navigable': this.variant !== 'header',
      'menu-entry--header': this.variant === 'header',
      'menu-entry--action': this.variant === 'action',
    };
  }
}
